import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectAuthenticated } from '../auth/authSlice';
import Login from '../auth/Login';
import ListaUsuarios from './buscar/ListaUsuarios';
import BuscarUsuario from './buscar/BuscarUsuario';
import { editEmail } from './buscar/buscarUsuarioSlice';


export default function AdminUsuarios () {
    const navigate = useNavigate();
    const userAuthenticated = useSelector(selectAuthenticated);
    const dispatch = useDispatch();
    
    /* useEffect(() => {
        if (!userAuthenticated) {
            navigate('/login');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAuthenticated]); */

    function onClickHandler(e) {
        e.preventDefault();
        const target = e.target;
        switch(target.id) {
        case 'todos':
            dispatch(editEmail({
                key: 'email',
                value: ''
            }));
            break;
        case 'crear':
            navigate('/usuario');
            break;
        case 'responsables':
            navigate('/usuarios/responsables');
            break;
        case 'borrar':
            dispatch(editEmail({
                key: 'email',
                value: ''
            }));
            break;
        }
    }

    if (!userAuthenticated) {
        return <Login />;
    }

    return (
        <> 
            <div className='title'>
                <h2>Administración de usuarios</h2>
            </div>
            <button id='volver' onClick={() => navigate('/')}>Atrás</button>
            <BuscarUsuario onClickHandler={onClickHandler} />
            <div className="buttons-fullpage">
                <button id='todos' onClick={onClickHandler}>Listar todos</button>
                <button id='responsables' onClick={onClickHandler}>Gestionar responsables de plataforma</button>
            </div>
            <ListaUsuarios />
        </>
    );
}